import {
  QueryKey,
  UseQueryOptions,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import JsonApiResponse from '@/models/JsonApiResponse';
import { useListCache } from './query/v2/useCacheManager';
import { Model as BaseModel } from '@/models/Model';

export type UseQueryInput<
  Model extends BaseModel,
  TError = unknown,
  TQueryKey extends QueryKey = QueryKey,
> = UseQueryOptions<
  JsonApiResponse<Model>,
  TError,
  JsonApiResponse<Model>,
  TQueryKey
>;

export default function useListService<
  Model extends BaseModel,
  TError = unknown,
  TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryInput<Model, TError, TQueryKey>) {
  const { data, ...rest } = useQuery(options);

  const queryClient = useQueryClient();

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: options.queryKey });

  const cacheManager = useListCache<Model>(options.queryKey as QueryKey);

  return {
    ...rest,
    ...data,
    results: data?.results ?? [],
    invalidate,
    cacheManager,
  };
}
